export default "__VITE_ASSET__6bb5fc06__"